import { action, ActionType } from "typesafe-actions";

import { IError } from "../../../redux/actions/errorHandlingAction";

import { ISearchParams } from "../types/app-search.types";

export enum AppSearchActions {
  Clear = "AppSearch/Clear",
  Search = "AppSearch/Search",
  SearchFailure = "AppSearch/SearchFailure",
  SearchSuccess = "AppSearch/SearchSuccess",
}

export const clearSearch = () => action(AppSearchActions.Clear);

export const searchApp = (endpoint: string, dataKey: string, params: ISearchParams) =>
  action(AppSearchActions.Search, { endpoint, dataKey, params });
export const searchAppFailure = (error: IError) => action(AppSearchActions.SearchFailure, error);
export const searchAppSuccess = (results: any) => action(AppSearchActions.SearchSuccess, results);

const actionCreators = {
  clearSearch,

  searchApp,
  searchAppFailure,
  searchAppSuccess,
};

export type AppSearchActionType = ActionType<typeof actionCreators>;
